import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatINR } from "@/lib/api";

const STATUS_LABEL = {
  created: "Awaiting Payment",
  paid: "Paid · Preparing",
  shipped: "Shipped",
  delivered: "Delivered",
  cancelled: "Cancelled",
  failed: "Failed",
};

const STATUS_COLOR = {
  created: "text-[#6b6b6b]",
  paid: "text-[#8b3a3a]",
  shipped: "text-[#c8532e]",
  delivered: "text-[#3a6a3a]",
  cancelled: "text-[#6b6b6b]",
  failed: "text-[#b52929]",
};

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/orders/mine").then((r) => setOrders(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen" data-testid="orders-page">
      <div className="max-w-[1200px] mx-auto px-3 md:px-6 py-8">
        <h1 className="font-display text-3xl md:text-5xl font-semibold text-[#1a1d29] mb-6">Your Orders</h1>

        {loading ? (
          <div className="card p-6 text-sm text-[#6b6b6b]">Loading…</div>
        ) : orders.length === 0 ? (
          <div className="card p-12 text-center">
            <div className="font-display text-2xl font-semibold">No orders yet</div>
            <Link to="/shop" className="btn-primary inline-block mt-4">Start shopping</Link>
          </div>
        ) : (
          <div className="space-y-4">
            {orders.map((o) => (
              <div key={o.id} className="card overflow-hidden" data-testid={`order-row-${o.id}`}>
                <div className="p-4 bg-[#faf7f2] border-b border-[#e0d8c8] grid grid-cols-1 sm:grid-cols-4 gap-3 text-sm">
                  <div>
                    <div className="text-xs uppercase tracking-[0.16em] text-[#6b6b6b]">Placed</div>
                    <div className="font-medium">{new Date(o.created_at).toLocaleDateString()}</div>
                  </div>
                  <div>
                    <div className="text-xs uppercase tracking-[0.16em] text-[#6b6b6b]">Total</div>
                    <div className="font-medium">{formatINR(o.amount)}</div>
                  </div>
                  <div>
                    <div className="text-xs uppercase tracking-[0.16em] text-[#6b6b6b]">Ship to</div>
                    <div className="font-medium">{o.shipping?.full_name}</div>
                  </div>
                  <div className="sm:text-right">
                    <div className="text-xs uppercase tracking-[0.16em] text-[#6b6b6b]">Order #</div>
                    <div className="font-mono text-xs">{o.id.slice(0, 12)}</div>
                  </div>
                </div>
                <div className="p-4">
                  <div className={`font-display text-xl font-semibold ${STATUS_COLOR[o.status] || ""}`}>
                    {STATUS_LABEL[o.status] || o.status}
                  </div>
                  <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-4">
                    {o.items.map((it, i) => (
                      <div key={i} className="flex gap-3">
                        <div className="w-16 h-20 bg-[#faf7f2] border border-[#e0d8c8] rounded-md overflow-hidden shrink-0">
                          {it.image && <img src={it.image} className="w-full h-full object-cover" alt="" />}
                        </div>
                        <div className="text-sm">
                          <div className="font-medium">{it.name}</div>
                          <div className="text-xs text-[#6b6b6b]">
                            {it.size || ""}{it.size && it.color ? " · " : ""}{it.color || ""} · Qty {it.quantity}
                          </div>
                          <Link to={`/product/${it.product_id}`} className="ec-link text-xs mt-1 inline-block">Buy again</Link>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
